import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useProductReviewFilters } from '../../../../../../lib/hooks/useProductReviewFilters'

import { ActionButton, Actions, Body, Wrapper } from './styles'

export const ActionsBar: React.FC<{ onApplyFilters: () => void }> = ({ onApplyFilters }) => {
  const {
    collections: {
      filtering: { filterModal: strings },
    },
  } = useTranslation()
  const { updateFilters } = useProductReviewFilters()

  const onClick = () => updateFilters({})

  return (
    <Body>
      <Wrapper>
        <Actions>
          <ActionButton variant='ghost' onClick={onClick}>
            {strings.resetAllFiltersCta}
          </ActionButton>
          <ActionButton onClick={onApplyFilters}>{strings.applyFiltersCta}</ActionButton>
        </Actions>
      </Wrapper>
    </Body>
  )
}
